import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import stores from './stores';
import App from './App';
import './index.css';

ReactDOM.render(
  <BrowserRouter>
    <Provider {...stores}>
    <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);
